export var TrackerClients;
(function (TrackerClients) {
    TrackerClients["websdk"] = "websdk";
    TrackerClients["osm"] = "osm-client-script";
    TrackerClients["identitySdk"] = "identity-sdk";
})(TrackerClients || (TrackerClients = {}));
